// _common.js

export function common() {
  const header = document.getElementById("js-header");

  if (header) {
    const headerScroll = () => {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 1 && window.innerWidth > 768) {
          header.classList.add("is-scroll");
        } else {
          header.classList.remove("is-scroll");
        }
      });
    };

    headerScroll();
  } else {
    console.error("Header element not found.");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // js-slideIn アニメーション
  let slideInElements = document.querySelectorAll(".js-slideIn");
  slideInElements.forEach(function (slideInElement) {
    gsap.fromTo(
      slideInElement,
      { y: 20, autoAlpha: 0 },
      {
        y: 0,
        autoAlpha: 1,
        delay: 0.5,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slideInElement,
          start: "top bottom",
          toggleActions: "play none none reverse",
        },
      }
    );
  });

  // 上下アニメーション
  if (document.querySelector(".js-balloon")) {
    gsap.to(".js-balloon", {
      y: -5,
      duration: 0.7,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
    });
  }

  // ファーストビューの要素を取得
  let fv =
    document.querySelector(".c-mv") || document.querySelector(".c-mv-lower");

  // ヘッダーナビゲーションの要素を取得
  let headerNav = document.querySelector(".header__nav");

  // ヘッダーリンクを取得
  let headerLinks = document.querySelectorAll(".p-header__list a");

  if (fv) {
    // スクロールイベントを監視
    window.addEventListener("scroll", function () {
      let fvHeight = fv.offsetHeight;

      if (window.scrollY > fvHeight) {
        headerLinks.forEach(function (link) {
          link.classList.add("is-active");
        });
      } else {
        headerLinks.forEach(function (link) {
          link.classList.remove("is-active");
        });
      }
    });
  }

  // 特定の要素が画面の一番上に来たときにis-whiteクラスを付与
  const checkElements = ["p-entry", "p-contact", "p-footer"];

  window.addEventListener("scroll", function () {
    let isWhiteAdded = false;
    checkElements.forEach(function (className) {
      let element = document.querySelector(`.${className}`);
      if (element) {
        let rect = element.getBoundingClientRect();
        if (rect.top <= 0 && rect.bottom >= 0) {
          isWhiteAdded = true;
        }
      }
    });

    headerLinks.forEach(function (link) {
      if (isWhiteAdded) {
        link.classList.add("is-white");
      } else {
        link.classList.remove("is-white");
      }
    });
  });
});


// fvテキストアニメーション
function BgFadeAnime() {
  $(".bgLRextendTrigger").each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("bgLRextend");
    } else {
      $(this).removeClass("bgLRextend");
    }
  });

  $(".bgappearTrigger").each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("bgappear");
    } else {
      $(this).removeClass("bgappear");
    }
  });
}

$(window).scroll(function () {
  BgFadeAnime();
});

$(window).on("load", function () {
  BgFadeAnime();
});
